var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1FA637",
    d: "M11.102 11.102v7.072a1.146 1.146 0 11-2.291 0v-7.072H1.739a1.146 1.146 0 110-2.291h7.072V1.739a1.146 1.146 0 112.291 0v7.072h7.072a1.146 1.146 0 110 2.291h-7.072z"
  })));
}
export default SvgExpand;